import { Heading, VStack, Input, Button, Box, Table, Thead, Tbody, Tr, Th, Td, Select, useToast, Checkbox, Text, useColorModeValue, useDisclosure, Modal, ModalOverlay, ModalContent, ModalHeader, ModalBody, ModalFooter, ModalCloseButton, Collapse, HStack } from '@chakra-ui/react';
import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { Tooltip } from "@chakra-ui/react";
import { jwtDecode } from "jwt-decode";
import { format } from 'date-fns';
import { useNavigate } from "react-router-dom";
import { FiEdit, FiCheck, FiX } from "react-icons/fi";
import { Course } from './types';
import { toUtcISOString, parseUtc, fmtLocal } from "../../utils/dates";
import { useTenant } from "../Routers/TenantContextProvider";

interface Tenant {
  tenant_id: number;
  name: string;
  description: string;
  is_active: boolean;
}

// Define the expected structure of the token payload
interface TokenPayload {
  sub: string;       // Typically the username or user ID
  role_id: number;   // Role ID
  tenant_id: number; // Tenant ID
  exp?: number;      // Expiration timestamp (optional)
}

const CourseManager = () => {
  const [courses, setCourses] = useState<Course[]>([]);
  const [selectedTenant, setSelectedTenant] = useState<number | null>(null);
  const navigate = useNavigate();

  const toast = useToast();
  const tableHeaderbg = useColorModeValue("gray.200", "gray.700");

  const { tenant, loading, error } = useTenant();


  const [isAddingNew, setIsAddingNew] = useState(false);
  const [editRow, setEditRow] = useState<number | null>(null); // Track the row currently being edited
  const [newCourse, setNewCourse] = useState<Course | null>(null);

  // Function to get tenant_id from the token
  const getTenantIdFromToken = (token: string): number | null => {
    try {
      const decoded: TokenPayload = jwtDecode<TokenPayload>(token);
      return decoded.tenant_id || null;
    } catch (error) {
      console.error("Error decoding token:", error);
      return null;
    }
  };


    // Function to get tenant_id from the token
    const getUserRoleIdFromToken = (token: string): number | null => {
      try {
        const decoded: TokenPayload = jwtDecode<TokenPayload>(token);
        return decoded.role_id || null;
      } catch (error) {
        console.error("Error decoding token:", error);
        return null;
      }
    };

  const formatDateTime = (dateString: string): string => {
    try {
      const date = new Date(dateString);
      return format(date, 'dd/MM/yyyy hh:mm a'); // Format: DD/MM/YYYY HH:MM am/pm
    } catch (error) {
      console.error('Invalid date format:', error);
      return 'Invalid date'; // Return a fallback for invalid dates
    }
  };

  const formatDate = (dateString: string): string => {
    try {
      const date = new Date(dateString);
      return format(date, 'dd/MM/yyyy'); // Format: DD/MM/YYYY
    } catch (error) {
      console.error('Invalid date format:', error);
      return 'Invalid date'; // Return a fallback for invalid dates
    }
  };

  // Set tenant ID on mount
  useEffect(() => {
    const token = localStorage.getItem("token");
    if (token) {
      const tenantId = getTenantIdFromToken(token);
      console.log("Tenant ID:", tenantId);
      setSelectedTenant(tenantId);
    }
  }, []);

  // Fetch enrolled students when tenant ID is set
  useEffect(() => {
    if (selectedTenant) {
      fetchCourses();
    }
  }, [selectedTenant]);

  const fetchCourses = async () => {
    if (!selectedTenant) return;

    try {
      const tenantsapiurl = process.env.REACT_APP_TENANTS_API_URL || 'https://default-url.com';
      const response = await axios.get(`${tenantsapiurl}/${selectedTenant}/courses`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('token')}`,
        },
      });
      setCourses(response.data);
    } catch (error) {
      console.error("Failed to load enrolled students", error);
    }
  };

  const handleReviewCourse = (course_id: number) => {
    // Placeholder function

    const token = localStorage.getItem("token");
    if (token) {
      const role_id = getUserRoleIdFromToken(token);
/*       if (role_id == 1)
        {
          navigate(`/coaching/super/dashboard/course-manager/review-course/${course_id}`);
        }
        else if(role_id == 2)
        {
          navigate(`/coaching/admin/dashboard/course-manager/review-course/${course_id}`);
        } */

          if (role_id == 1)
          {
       
            navigate(`/platform/super/course-manager/review-course/${course_id}`);
          }
          else if(role_id == 2 && tenant)
          {

            navigate(`/platform/${tenant.tenant_slug}/app/course-manager/review-course/${course_id}`);
          }
    }
   
   
  };

  const handleAddNewCourse = () => {
    setIsAddingNew(true);
    setNewCourse({ tenant_id:0, id: 0, title: '', description: '',  is_active: true , created_at: new Date(), updated_at: new Date()});
  };

  const handleRemoveNewCourse = () => {
    setIsAddingNew(false);
    setNewCourse(null);
  };

  const handleSaveCourse = async (course: Course) => {
    try {
        
        if (selectedTenant) {
        course.tenant_id = selectedTenant
        }

        const payload = {
            title: course.title,
            description: course.description,
            created_at: course.created_at,
            updated_at: course.updated_at,
            tenant_id: selectedTenant || course.tenant_id,
            is_active: course.is_active,
        };
      const apiurl = process.env.REACT_APP_API_URL || 'https://default-url.com';
      
      console.log("printing course user payload",payload);

      const response = await axios.post(apiurl+`/create-course/`, payload, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('token')}`
        }
      });
      setCourses([...courses, response.data]);
      setIsAddingNew(false);
      setNewCourse(null);
      toast({ title: "Course User added successfully", status: "success" });
    } catch (error) {
      console.error("Failed to save Course User", error);
      toast({ title: "Failed to add Course User", status: "error" });
    }
  };

  const handleUpdateCourse = async (course: Course) => {
    try {
        
        if (selectedTenant) {
        course.tenant_id = selectedTenant
        }

        const payload = {
            title: course.title,
            description: course.description,
            created_at: course.created_at,
            updated_at: course.updated_at,
            tenant_id: selectedTenant || course.tenant_id,
            is_active: course.is_active,
        };
      const apiurl = process.env.REACT_APP_API_URL || 'https://default-url.com';
     
      console.log("Printing Token from Update" + localStorage.getItem("token"));
      await axios.put(apiurl+`/update-course/${course.id}`, payload, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('token')}`
        }
      });
      fetchCourses();
      setEditRow(null); // Reset edit mode after successful update
      toast({ title: "Course updated successfully", status: "success" });
    } catch (error) {
      console.error("Failed to update Course", error);
      toast({ title: "Failed to update Course", status: "error" });
    }
  };

  const handleEditRow = (user_id: number) => {
    setEditRow(user_id);
    setIsAddingNew(false); // Disable add tenant while editing
  };

  const handleCancelEdit = () => {
    setEditRow(null);
    setIsAddingNew(false);
  };


  return (
    <Box as="main" mx="auto" p={10} >
      <VStack>
        <Heading size={"md"}>Course Manager</Heading>
      </VStack>
            <Box mt={4}>
               <Text fontWeight="bold">Existing Platform Courses Details</Text>
        <Button  mt={2} borderRadius={"sm"} fontSize="sm" fontWeight="normal" onClick={handleAddNewCourse} isDisabled={isAddingNew || editRow !== null}>
          + Course
        </Button>
      </Box>
      <Box mt={4}>
       
        <Table mt={4} borderColor={"gray.300"} borderWidth={1} borderRadius="sm">
          <Thead fontSize="12">
            <Tr bgColor={tableHeaderbg}>
              <Th>ID</Th>
              <Th>Title</Th>
              <Th>Description</Th>
              <Th>Created At</Th>
              <Th>Updated At</Th>
              <Th>Status</Th>
              <Th>Edit Course</Th>
              <Th>Update Terms & Classes</Th>
            </Tr>
          </Thead>
          <Tbody fontSize="12">
              {isAddingNew && newCourse && (
                <Tr>
                <Td>New</Td>
                <Td>
                    <Input
                    size="sm"
                    fontSize="sm"
                    value={newCourse.title}
                    onChange={(e) =>
                        setNewCourse({ ...newCourse, title: e.target.value })
                    }
                    />
                </Td>
                <Td>
                    <Input
                    size="sm"
                    fontSize="sm"
                    value={newCourse.description}
                    onChange={(e) =>
                        setNewCourse({ ...newCourse, description: e.target.value })
                    }
                    />
                </Td>
                <Td>
                    <Text fontSize="sm">{new Date().toLocaleString()}</Text>
                </Td>
                <Td>
                    <Text fontSize="sm">{new Date().toLocaleString()}</Text>
                </Td>
                <Td>
                    <Checkbox
                    isChecked={newCourse.is_active}
                    onChange={(e) =>
                        setNewCourse({ ...newCourse, is_active: e.target.checked })
                    }
                    />
                </Td>
                <Td>
                <HStack>
                    <Tooltip label="Save">
                    <Button size="sm" onClick={() => handleSaveCourse(newCourse)}>
                        <FiCheck />
                    </Button>
                    </Tooltip>
                    <Tooltip label="Cancel">
                    <Button size="sm" ml={2} onClick={handleRemoveNewCourse}>
                        <FiX />
                    </Button>
                    </Tooltip>
                </HStack>
                </Td>
                </Tr>
            )}
            {courses.map((course) => (
                <Tr
                key={course.id}
                opacity={editRow && editRow !== course.id ? 0.5 : isAddingNew ? 0.5 : 1}
                >
                <Td>{course.id}</Td>
                <Td>
                    {editRow === course.id ? (
                    <Input
                        size="sm"
                        fontSize="sm"
                        value={course.title}
                        onChange={(e) => {
                        course.title = e.target.value;
                        setCourses([...courses]);
                        }}
                    />
                    ) : (
                    course.title
                    )}
                </Td>
                <Td>
                    {editRow === course.id ? (
                    <Input
                        size="sm"
                        fontSize="sm"
                        value={course.description}
                        onChange={(e) => {
                        course.description = e.target.value;
                        setCourses([...courses]);
                        }}
                    />
                    ) : (
                    course.description
                    )}
                </Td>
                <Td>
                    {editRow === course.id ? (
                    <Text fontSize="sm">{fmtLocal(course.created_at)}</Text>
                    ) : (
                    fmtLocal(course.created_at)
                    )}
                </Td>
                <Td>
                    {editRow === course.id ? (
                    <Text fontSize="sm">{fmtLocal(course.updated_at)}</Text>
                    ) : (
                    fmtLocal(course.updated_at)
                    )}
                </Td>
                <Td>
                    {editRow === course.id ? (
                    <Checkbox
                        isChecked={course.is_active}
                        onChange={(e) => {
                        course.is_active = e.target.checked;
                        setCourses([...courses]);
                        }}
                    />
                    ) : course.is_active ? (
                    "Active"
                    ) : (
                    "Inactive"
                    )}
                </Td>
                <Td>
                    {editRow === course.id ? (
                    <HStack>
                        <Tooltip label="Update">
                        <Button size="sm" onClick={() => handleUpdateCourse(course)}>
                            <FiCheck />
                        </Button>
                        </Tooltip>
                        <Tooltip label="Cancel">
                        <Button size="sm" ml={2} onClick={handleCancelEdit}>
                            <FiX />
                        </Button>
                        </Tooltip>
                        </HStack>
                    ) : (
                    <Tooltip label="Edit">
                        <Button size="sm" onClick={() => handleEditRow(course.id)}>
                        <FiEdit />
                        </Button>
                    </Tooltip>
                    )}
                </Td>
                <Td>
                  <Tooltip label="Review Terms & Classes for the course">
                    <Button size="sm" onClick={() => handleReviewCourse(course.id)}>
                      Terms & Classes
                    </Button>
                  </Tooltip>
                </Td>
                </Tr>
            ))}

            </Tbody>

        </Table>
      </Box>

    </Box>
  );
};

export default CourseManager;
